import * as React from 'react'
import s from './summary-container.scss'

export const SummaryContainer: React.FC = ({children}) => <div className={s.container}>{children}</div>
